module.exports = __webpack_public_path__ + "static/media/jam-bus.b4e099d9.svg";